import React from 'react'
import { ICompaniesMarquee as IContentfulCompaniesMarquee } from 'marketing-site/@types/generated/contentful'
import { CompaniesMarquee } from 'marketing-site/src/library/components/CompaniesMarquee'
import { transformLogo } from 'marketing-site/src/transformers/elements/ContentfulLogo'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulCompaniesMarquee = (companiesMarquee: IContentfulCompaniesMarquee) => {
  return (
    <EntryMarker entry={companiesMarquee}>
      {() => <CompaniesMarquee {...transformCompaniesMarquee(companiesMarquee)} />}
    </EntryMarker>
  )
}

export function transformCompaniesMarquee(companiesMarquee: IContentfulCompaniesMarquee) {
  return {
    logos: companiesMarquee.fields.logos.map(transformLogo),
  }
}
